export enum ActiveSuspended {    
    Active = 0,
    Suspended = 1
}